import React from 'react';
import styled from 'styled-components';
import { Order } from '@/apis/order/interface';
import { SECONDS_OF_TEN_MINUTE } from '@/constants/constant';
import useTimer from '@/hooks/common/useTimer';
import TimeIcon from '@/components/icon/TimerIcon';

const TimeInformations = React.memo(({ order }: { order: Order }) => {
  const orderTime = order.sendAt ? new Date(order.sendAt).getTime() : null;
  const nowTime = new Date().getTime();
  const gapSeconds = !!orderTime ? (nowTime - orderTime) / 1000 : 0;
  const isEnabledTime = !!orderTime && gapSeconds < SECONDS_OF_TEN_MINUTE;
  const remainingTime = SECONDS_OF_TEN_MINUTE - gapSeconds;

  const initMin = Math.floor(remainingTime / 60);
  const initSec = Math.floor(remainingTime % 60);
  const { min, sec, isEnableTimer } = useTimer({
    active: isEnabledTime,
    initMin,
    initSec
  });

  return (
    <>
      <TimeInformation>
        <TimeIcon />
        {isEnableTimer
          ? `${min}분 ${sec}초 안에 조제 여부를 결정해주세요`
          : '조제접수 할 수 있는 시간이 지났어요'}
      </TimeInformation>
    </>
  );
});

export default TimeInformations;

const TimeInformation = styled.div`
  font-size: 20px;
  font-weight: 500;
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  & > svg {
    margin-right: 8px;
  }
  ${({ theme }) => `
    color: ${theme.DF_COLOR.RED600};
  `};
`;
